<template>
  <div>
    <div v-for="(error, i) in errors" :key="i" class="error-wrapper">
      <UiErrorMessageInput :error="error" />
    </div>
  </div>
</template>

<script>
import UiErrorMessageInput from '@/components/errors/UiErrorMessageInput.vue'

export default {
  components: { UiErrorMessageInput },
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.error-wrapper {
  padding: 6px 6px 0 6px;
  color: $color-error;

  @include createFlex(flexbox, nowrap, row, flex-start, center, center);
}
</style>
